<template>
    <div class="ngdialog-content">
        <dialog-header :showClose="false">
            <h4>{{ $t('verifyuser.verify_account') }}</h4>
        </dialog-header>

        <form name="inviteForm" novalidate class="form">
            <div class="ngdialog__body" v-html="$t('verifyuser.verify_account_text', { email: '<b>'+userData.email+'</b>' })"></div>

            <div class="ngdialog__button-group ngdialog__button-group--column">
                <div class="ngdialog__button-group__item">
                    <button
                        style="margin-bottom:5px;"
                        type="button"
                        class="ngdialog__button ngdialog__button--primary"
                        @click="checkVerification"
                    >
                        <span class="ngdialog__button__text">{{ $t('verifyuser.account_verified') }}</span>
                    </button>
                </div>
                <div class="ngdialog__button-group__item">
                    <button
                        style="margin-bottom:5px;"
                        type="button"
                        class="ngdialog__button ngdialog__button--primary"
                        @click="resend"
                    >
                        <span class="ngdialog__button__text">{{ $t('verifyuser.resend_verification_mail') }}</span>
                    </button>
                </div>
                <div class="ngdialog__button-group__item">
                    <button
                        type="button"
                        class="ngdialog__button ngdialog__button--primary"
                        @click="logout"
                    >
                        <span class="ngdialog__button__text">{{ $t('navigation.logout') }}</span>
                    </button>
                </div>
            </div>
        </form>

        <notification v-if="info" :title="info_title" :message="info_message" :what="'success'" />
        <notification v-if="error" :title="error_title" :message="error_message" :what="'error'" />
    </div>
</template>

<script>
// import * as api from '@/api';
import DialogHeader from '@/components/DialogHeader';
import Notification from '@/components/Notification';
import { mapGetters } from 'vuex';

export default {
    name: 'verify-user',
    components: {
        DialogHeader,
        Notification,
    },
    computed: {
        ...mapGetters(['userData']),
    },
    mounted() {
    },
    data() {
        let data = {
            info: false,
            info_title: 'notifications.sent',
            info_message: 'verifyuser.resend_verification_success_text',
            error: false,
            error_title: 'verifyuser.failed',
            error_message: 'verifyuser.not_yet_verified',
        };

        return data;
    },
    methods: {
        logout() {
            this.$emit('close');
            this.$store.dispatch('logout').then(() => {
                this.$router.push('/');
            });
        },
        resend() {
            const that = this;
            this.$store.dispatch('resendVerificationEmail', { email: this.userData.email }).then(() => {
                that.info = true;
                setTimeout(function(){
                    that.info = false;
                }, 3000);
            });
        },
        checkVerification() {
            const that = this;
            this.$store.dispatch('loadUserDataSync').then(() => {
                if (this.userData.hasOwnProperty('email_confirmed') && this.userData.email_confirmed === false) {
                    that.error = true;
                    setTimeout(function(){
                        that.error = false;
                    }, 3000);
                } else {
                    this.$emit('close');
                }
            });
        },
    },
};
</script>
